import { render, staticRenderFns } from "./ServicePage3.vue?vue&type=template&id=725a6d0e"
import script from "./ServicePage3.vue?vue&type=script&lang=js"
export * from "./ServicePage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports